import { useEffect } from 'react';
import { CUSTOMER_API_BASE_URL, ERP_API_BASE_URL, NOTIFY_API_BASE_URL, SVC_PP_API_BASE_URL } from '../../constants';

const usePreconnect = () => {
    useEffect(() => {
        const apiUrls = [
            { envVar: 'REACT_APP_SVC_PP_API_BASE_URL', url: SVC_PP_API_BASE_URL },
            { envVar: 'REACT_APP_ERP_API_BASE_URL', url: ERP_API_BASE_URL },
            { envVar: 'REACT_APP_CUSTOMER_API_BASE_URL', url: CUSTOMER_API_BASE_URL },
            { envVar: 'REACT_APP_NOTIFY_API_BASE_URL', url: NOTIFY_API_BASE_URL },
        ];

        const links = [];

        apiUrls.forEach(({ envVar, url }) => {
            if (!url) {
                console.warn(`Preconnect: Environment variable ${envVar} is not defined`);
                return;
            }

            try {
                const link = document.createElement('link');
                link.rel = 'preconnect';
                link.href = url;
                link.crossOrigin = 'anonymous';

                document.head.appendChild(link);
                links.push(link);
                
            } catch (error) {
                console.error(`Preconnect: Failed to add preconnect for ${url}`, error);
            }
        });

        return () => {
            links.forEach(link => {
                try {
                    if (document.head.contains(link)) {
                        document.head.removeChild(link);
                        
                    }
                } catch (error) {
                    console.error('Preconnect: Failed to remove preconnect link', error);
                }
            });
        };
    }, []);
};

export default usePreconnect;
